<template>
  <div class="app-cursor cursor">
    <svg class="cursor__element" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 77 77">
      <path
        fill="#ECDDD0"
        stroke="#none"
        d="M24.6 72.1C14.9 69.8 7.3 62.2 5 52.4-.3 43.9-.3 33.1 5 24.6 7.3 14.9 14.9 7.3
         24.6 5 33.1-.3 43.9-.3 52.3 5 62 7.3 69.6 14.9 72 24.7c5.3 8.5 5.3 19.3 0 27.8-2.3
         9.7-9.9 17.3-19.7 19.7-8.4 5.1-19.2 5.1-27.7-.1z"
      />
    </svg>
  </div>
</template>

<script>
export default {
  name: 'AppCursor',
};
</script>

<style lang="scss" scoped>
.cursor {
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;

  pointer-events: none;

  mix-blend-mode: multiply;
  opacity: 0.5;

  &__element {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 30px;
    height: 30px;
  }

  @include mq($until: ipadP) {
    display: none;
  }

  @include mq($and: $is-touch-device) {
    display: none;
  }
}
</style>
